import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { SEO } from "@/components/SEO";
import { BUSINESS } from "@/data/business";

const NotFound = () => (
  <>
    <SEO
      title="Page Not Found | Blossom Spa Madhapur"
      description="The page you're looking for doesn't exist. Return to Blossom Spa Madhapur's home page."
      path="/404"
    />
    <section className="min-h-[70vh] flex flex-col items-center justify-center text-center px-5 pt-20">
      <p className="font-serif text-6xl text-spa-sage">404</p>
      <h1 className="font-serif text-3xl text-spa-slate mt-4">
        This page has wandered off
      </h1>
      <p className="text-spa-textMuted mt-3 max-w-sm">
        Let's get you back to a calmer place.
      </p>
      <div className="flex flex-wrap justify-center gap-4 mt-8">
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="bg-spa-slate text-spa-cream px-7 py-3.5 rounded-full text-sm font-medium hover:bg-spa-slateHover transition-all"
        >
          Back Home
        </Link>
        <a
          href={`tel:${BUSINESS.phoneClean}`}
          data-testid="notfound-call-button"
          className="flex items-center gap-2 border border-spa-slate/20 text-spa-slate px-7 py-3.5 rounded-full text-sm font-medium hover:bg-spa-muted transition-all"
        >
          <Phone className="w-4 h-4" /> Call Us
        </a>
      </div>
    </section>
  </>
);

export default NotFound;
